export const FORCE_UPDATE = 'FORCE_UPDATE';
export type ForceUpdateAction = {
  type: string;
};
export default function forceUpdate() {
  return {
    type: FORCE_UPDATE
  };
}
